import { useMemo, useState } from "react";
import MemeCard from "@/components/feature/MemeCard";
import { memeCategories, memeItems } from "@/mocks/memes";

const tabs = [{ slug: "all", name: "全部" }, ...memeCategories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestSection() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () => (active === "all" ? memeItems : memeItems.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-xl">
            <span className="text-xs tracking-[0.2em] text-primary-600">JUST&nbsp;IN</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">今日最新收录</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              刚整理好的一批素材，点标签就能只看你关心的那一类。看到合适的直接进详情页存走。
            </p>
          </div>

          <div className="flex w-fit flex-wrap gap-1 rounded-full border border-background-300 bg-background-100 px-1 py-1">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => setActive(tab.slug)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === tab.slug
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((item) => (
              <MemeCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-100 p-10 text-center text-sm text-foreground-500">
            这个分类暂时还没有内容，换个标签看看呗。
          </p>
        )}
      </div>
    </section>
  );
}